import React, { useState, useEffect ,useRef} from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/Global/layout";
// import SpotlightDetail from "../components/Global/spotlightDetail";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SocialShare from "../components/Global/socialShare";
import ActionsButtons from "../components/Global/actionsButtons";
import BreadcrumbSchema from "../components/BreadcrumbSchema";

// import newsDetailsSpotlightBanner from "../common/images/NewsInsightsList/newsDetailsSpotlightBanner.png";
// import newsListSpotlightClip from "../common/images/NewsInsightsList/newsListSpotlightClip.png";
import rightArrow from "../common/images/Homepage/newsAndInsights/rightArrow.svg";
import backArrowIcon from "../common/images/NewsInsightsList/backArrowIcon.svg";
import newsListSpotlightBanner from "../common/images/NewsInsightsList/newsListSpotlightBanner.png";
// import newsListBrandMatrix from "../common/images/NewsInsightsList/newsListBrandMatrix.svg";
// import searchBoxBrandMatrix from "../common/images/NewsInsightsList/searchBoxBrandMatrix.svg";
import clockBlack from "../common/images/NewsInsightsList/clockBlack.svg";
import locationBlack from "../common/images/NewsInsightsList/locationBlack.svg";
import newsNavRightArrow from "../common/images/NewsInsightsList/newsNavRightArrow.svg";
import newsNavLeftArrow from "../common/images/NewsInsightsList/newsNavLeftArrow.svg";
import nextArrowBlack from "../common/images/NewsInsightsList/nextArrowBlack.svg";
import previousArrowBlack from "../common/images/NewsInsightsList/previousArrowBlack.svg";
import { transDate } from '../components/services/generic';
import SiteTrans from "../components/LangConfig/siteTrans.json";
import { format } from 'date-fns';

const Page = (props) => {
  let wpNews;
  let allNews;
 
  if(process.env.GATSBY_PREVIEW_MODE === "true"){ 
    wpNews = props.data.wpQuickreads;
    allNews = props.data.allWpQuickreads.edges
   }else{
    // allNews = props.data.allWpQuickreads.edges.filter(news => news.node.publishStatus.status !== 'private')
    // if(props.data.wpQuickreads.publishStatus.status !== 'private'){
    //   wpNews = props.data.wpQuickreads;
    // }
    wpNews = props.data.wpQuickreads;
    allNews = props.data.allWpQuickreads.edges.filter(news => news.node.publishStatus.status !== 'private')
  }
  // const wpNews = props.data.wpQuickreads;
  // const allNews = props.data.allWpQuickreads.edges.filter(news => news.node.publishStatus.status !== 'private');


  const limitedRelatedNews = allNews.filter(news => news.node.id !== wpNews.id).slice(0, 2);
  let content = wpNews.content ? wpNews.content : "";
  const wordsPerMinute = 200;
  const wordCount = content.split(/\s+/).length;
  const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);

  const [fragment, setFragment] = useState("");
  const [isFootnotesOpen, setIsFootnotesOpen] = useState(false)
  const footNotesDescriptionRef = useRef(null);
  useEffect(() => {
    if (window.location.hash.substr(1)) {
      setFragment(window.location.hash.substr(1));
    }
  });
  useEffect(() => {
    setTimeout(()=>{
     window.scrollTo({
       top: 0,
       left: 0,
       behavior: "smooth",
     });
    },30)
   }, [])
  useEffect(() => {
    if (fragment !== '') {
      scrollToElement(fragment);
    }
  }, [fragment]);

  const scrollToElement = (id) => {
    const offset = document.querySelector(".header").offsetHeight;
    const element = document.getElementById(id);

    if (element) {
      const offsetPosition = element.offsetTop - offset;
      toggleFootnotes(false)
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const translateDate = (enmonth,lang) => {
    var trans =  transDate(enmonth,lang);
    return trans;
}

  // const clickHandler = (e) => { };

  // const [isAboveRefPoint, setIsAboveRefPoint] = useState(true);
  const headerListenToScroll = () => {
    // const newsInsightsSectionPosition = document.getElementById(
    //   "spotlight-detail-title-ref"
    // )?.offsetTop;
    // const scrollPosition = window.scrollY;

    // if (scrollPosition < newsInsightsSectionPosition) {
    //   setIsAboveRefPoint(true);
    // } else {
    //   setIsAboveRefPoint(false);
    // }
  };

  useEffect(() => {
    window.addEventListener("scroll", headerListenToScroll);
    return () => {
      window.removeEventListener("scroll", headerListenToScroll);
    };
  }, []);

  const getFormatDate = (date) => {
    const rawpubDate = date;
    const formattedpubDate = `${rawpubDate.slice(0, 4)}-${rawpubDate.slice(4, 6)}-${rawpubDate.slice(6, 8)}`;
    const datepubObject = new Date(formattedpubDate);
    return datepubObject;
  }

  const dateObject = getFormatDate(wpNews.press_release_acf.publishedDate);
  const displayDate = format(dateObject, 'MMMM d, yyyy');
  var date = displayDate;
  var arr1 = date.split(' ');
  var arr2 = arr1[1].split(',');
  var arr3 = arr1[2];
  var month = arr1[0];

  console.log(arr2,"arr2");
  console.log(arr3,"arr3");
  console.log(arr1[0],"arr1");
  
  // var mainnewsandinsightsdate = translateDate(month,wpNews.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[wpNews.locale.id] +arr3;

  if(wpNews.locale.id=="ar"){
    var mainnewsandinsightsdate = arr2[0]+' '+translateDate(month,wpNews.locale.id)+SiteTrans.comma_article_txt[wpNews.locale.id]+arr3;
  }else{
    var mainnewsandinsightsdate = translateDate(month,wpNews.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[wpNews.locale.id]+arr3;
  }

  const toggleFootnotes = (event) => {
    setIsFootnotesOpen(!event);
    event && footNotesDescriptionRef ? footNotesDescriptionRef.current.style.maxHeight = null : footNotesDescriptionRef.current.style.maxHeight = `${footNotesDescriptionRef.current.scrollHeight}px`;
  }

  const languageCode = wpNews.locale.id == 'en_US' ? 'en' : wpNews.locale.id === 'ar' ? 'ar' : 'zh-hans'
  const viewAllLinkQuickReads = `/${languageCode}/quick-reads`;

  const publishedTranslatedLinks = wpNews.translated.filter(translation =>
    translation.locale.id === 'en_US' &&
    translation.localizedWpmlUrl && 
    translation.publishStatus.status !== 'private'
  );

  const link = wpNews.link // Original link
  const translatedLink = publishedTranslatedLinks.length && publishedTranslatedLinks[0].localizedWpmlUrl ? publishedTranslatedLinks[0].localizedWpmlUrl : wpNews.localizedWpmlUrl
  const segments = link.split('/'); // Split the link by slashes
  
  let modifiedLink;
  let translatedmodifiedLink;
  let translatedsegments;
  if(translatedLink == null){
    modifiedLink = segments.filter(segment => segment !== 'home').join('/');
  }else{
    translatedsegments = translatedLink.split('/'); 
    modifiedLink = segments.filter(segment => segment !== 'home').join('/'); // Remove "home" and join the segments
    translatedmodifiedLink = translatedsegments.filter(segment => segment !== 'home').join('/');
  }
  const contactpagelink = wpNews.locale.id === 'en_US' ? 'en' : wpNews.locale.id === 'ar' ? 'ar' : 'zh-hans'
  return (
    <Layout isAboveRefPoint={false} lang={wpNews.locale.id}
      translations={wpNews.translated}
      title={wpNews.seo.opengraphTitle ? wpNews.seo.opengraphTitle : null}
      description={wpNews.seo.opengraphDescription ? wpNews.seo.opengraphDescription : null}
      image={wpNews.featuredImage.node.sourceUrl ? wpNews.featuredImage.node.sourceUrl : null}
      translateURL={translatedmodifiedLink}
      langURL={modifiedLink}
      currentPage={wpNews}
      pageUrl={wpNews.link}
      pageId={wpNews.locale.id}
    >

<BreadcrumbSchema
                    PageTitle={wpNews.title}
                    defaultPageName={"Quick Reads"}
                    pageUrl={"https://jameelmotors.com"+wpNews.link}
                    langUrl={"https://jameelmotors.com/"+contactpagelink+"/quick-reads"}
                />
      <div className="news-details-wrapper position-relative">
        {/* <SpotlightDetail
          clipImage={newsListSpotlightClip}
          image={wpNews.featuredImage ? wpNews.featuredImage.node : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-spotlight.png"}
          links=''
          triggerScroll=""
          title=""
          description=""
        /> */}



        <section className="news-details-content-wrapper">
          <section className="back-news-wrapper">
            <div className="news-contents-wrapper">
              <div className="container">
                <div className="align-items-sm-center d-flex flex-column flex-sm-row gap-1 gap-md-3 justify-content-between">
                  <div className="d-flex gap-2">
                    <img
                      src={backArrowIcon}
                      alt="Jameel Motors"
                      className="back-arrow-icon"
                    />
                    <Link to={viewAllLinkQuickReads}><div className="back-to-label">{SiteTrans.back_to_quick_reads[wpNews.locale.id]}</div></Link>
                  </div>
                  <div className="align-self-end">
                    <SocialShare
                      title={wpNews.title}
                      ShareMail=""
                      // shareUrl={wpNews.link}
                      ShareCopy=""
                      lang={wpNews.locale.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="d-flex">
            {allNews.map((data, key) => {

              if (data.node.id === wpNews.id) {
                const previousData = key - 1;

                if (previousData >= 0) {

                  let content = allNews[previousData].node.content;
                  const wordsPerMinute = 200;
                  const wordCount = content.split(/\s+/).length;
                  const readingTimeMinutes = Math.ceil(
                    wordCount / wordsPerMinute
                  );
                  const dateObject = getFormatDate(allNews[previousData].node.press_release_acf.publishedDate);
                  const displayDate = format(dateObject, 'MMMM d, yyyy');


                  var date = displayDate;
                  var arr1 = date.split(' ');
                  var arr2 = arr1[1].split(',');
                  var arr3 = arr1[2];
                  var month = arr1[0];

                  console.log(arr2,"arr2");
                  console.log(arr3,"arr3");
                  console.log(arr1[0],"arr1");
                  
                  // var prevnewsandinsightsdate = translateDate(month,wpNews.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[wpNews.locale.id] +arr3;

                  if(wpNews.locale.id=="ar"){
                    var prevnewsandinsightsdate = arr2[0]+' '+translateDate(month,wpNews.locale.id)+SiteTrans.comma_article_txt[wpNews.locale.id]+arr3;
                  }else{
                    var prevnewsandinsightsdate = translateDate(month,wpNews.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[wpNews.locale.id]+arr3;
                  }

                  return (
                    <Link to={allNews[previousData].node.link} className="stickyCustomNav stickyCustomNavPrev">
                      <div className="news-previous-navigation-cards-wrapper news-navigation-wrapper">
                        <div className="position-relative d-flex flex-row news-previous-navigation-container align-items-center">
                          {/* <img
                        src={
                          allNews[previousData].node.featuredImage ? allNews[previousData].node.featuredImage.node.sourceUrl : 'https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png'
                        }
                        alt="Jameel Motors"
                        className="news-navigation-card-poster"
                      /> */}
                          <GatsbyImage className="news-navigation-card-poster"
                            image={getImage(allNews[previousData].node.featuredImage ? allNews[previousData].node.featuredImage.node : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png")}
                            alt={"Jameel Motors"} />

                          <div className="news-nav-gradient position-absolute"></div>
                          <div className="arrow-nav-label-wrapper position-absolute d-flex flex-column justify-content-center align-items-center gap-2">
                            <img
                              src={newsNavLeftArrow}
                              alt="Jameel Motors"
                              className="nav-arrows"
                            />
                            <div className="nav-label">
                            {SiteTrans.read_txt[wpNews.locale.id]}
                              <br />
                              {SiteTrans.previous_txt[wpNews.locale.id]}
                            </div>
                          </div>
                        </div>

                        <div className="news-navigation-card-title font-md">
                          {
                            allNews[previousData].node.press_release_acf
                              .shortTitle
                          }
                        </div>

                        <div className="nav-location-date-clock-wrapper flex-row justify-content-start align-items-center">
                          <img
                            src={locationBlack}
                            alt="Jameel Motors"
                            className="location-icon"
                          />
                          <span className="location-label">
                            {
                              allNews[previousData].node.press_release_acf
                                .location
                            }
                          </span>
                          <div className="news-location-divider"></div>
                          <span className="location-label">
                            {
                              prevnewsandinsightsdate
                            }
                          </span>
                          <div className="news-location-divider"></div>
                          <img
                            src={clockBlack}
                            alt="Jameel Motors"
                            className="clock-icon"
                          />
                          <span className="location-label">
                            {readingTimeMinutes} {SiteTrans.minute_read_txt[wpNews.locale.id]}
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                }
              }
            })}
            <div className="position-relative news-details-content">
              <div className="container">
                <div className="d-flex flex-column justify-content-start align-items-start main-title-wrapper">
                  {/* <h2 className="main-title font-xl"> <div

                    dangerouslySetInnerHTML={{
                      __html: wpNews.title,
                    }}
                  /></h2> */}
                  <h1 className="main-title font-xl"
                        dangerouslySetInnerHTML={{
                          __html: wpNews.title,
                        }}
                        />
                  <div className="location-date-clock-wrapper d-flex flex-row justify-content-start align-items-center flex-wrap">
                    <img
                      src={locationBlack}
                      alt="Jameel Motors"
                      className="location-icon"
                    />
                    <span className="location-label">
                      {wpNews.press_release_acf.location}
                    </span>
                    <div className="news-location-divider"></div>
                    <span className="location-label">
                      {mainnewsandinsightsdate}
                    </span>
                    <div className="news-location-divider"></div>
                    <img
                      src={clockBlack}
                      alt="Jameel Motors"
                      className="clock-icon"
                    />
                    <span className="location-label">
                      {readingTimeMinutes} {SiteTrans.minute_read_txt[wpNews.locale.id]}
                    </span>
                  </div>
                  <img src={wpNews.featuredImage ? wpNews.featuredImage.node.sourceUrl : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-spotlight.png"} className="news-banner-image" alt="Jameel motors" />
                </div>
              </div>



              <div className="container news-details-content-box">
              <div
                  className="featured-caption"
                  dangerouslySetInnerHTML={{
                    __html: wpNews.featuredImage.node.caption ? wpNews.featuredImage.node.caption : null,
                  }}
                />
                <div
                  dangerouslySetInnerHTML={{
                    __html: wpNews.content,
                  }}
                />
              </div>
              {allNews.map((data, key) => {
              if (data.node.id === wpNews.id) {
                const previousData = key - 1;
                const nextData = key + 1;
                const totalItems = allNews.length;

              
                  return (
                    <div className="news-navigation-mobile-wrapper justify-content-between w-100">
                     {previousData >= 0 && <Link to={allNews[previousData]?.node?.link} className="align-items-center d-flex gap-2 w-100 justify-content-start">
                        <img
                          src={previousArrowBlack}
                          alt="Jameel Motors"
                          className="nav-arrows"
                        />
                        <div className="nav-label-mobile font-exsm">{SiteTrans.previous_txt[wpNews.locale.id]}</div>
                        <img
                          src={`${allNews[previousData]?.node.featuredImage ? allNews[previousData].node.featuredImage.node.sourceUrl : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png"}`}
                          alt="Jameel Motors"
                          className="news-navigation-card-poster-mobile"
                        />
                      </Link>}
                      {nextData <= totalItems - 1 && <Link to={allNews[nextData]?.node?.link} className="align-items-center d-flex gap-2 w-100 justify-content-end">
                        <img
                          src={`${allNews[nextData]?.node.featuredImage ? allNews[nextData].node.featuredImage.node.sourceUrl : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png"}`}
                          alt="Jameel Motors"
                          className="news-navigation-card-poster-mobile"
                        />
                        <div className="nav-label-mobile font-exsm">{SiteTrans.next_txt[wpNews.locale.id]}</div>
                        <img
                          src={nextArrowBlack}
                          alt="Jameel Motors"
                          className="nav-arrows"
                        />
                      </Link>}
                    </div>
                  );
        
              }
            })}
              {/* <div className="news-navigation-mobile-wrapper justify-content-between w-100">
                <div className="align-items-center d-flex gap-2 w-100 justify-content-start">
                  <img
                    src={previousArrowBlack}
                    alt="Jameel Motors"
                    className="nav-arrows"
                  />
                  <div className="nav-label-mobile font-exsm">PREVIOUS</div>
                  <img
                    src={newsListSpotlightBanner}
                    alt="Jameel Motors"
                    className="news-navigation-card-poster-mobile"
                  />
                </div>
                <div className="align-items-center d-flex gap-2 w-100 justify-content-end">
                  <img
                    src={newsListSpotlightBanner}
                    alt="Jameel Motors"
                    className="news-navigation-card-poster-mobile"
                  />
                  <div className="nav-label-mobile font-exsm">NEXT</div>
                  <img
                    src={nextArrowBlack}
                    alt="Jameel Motors"
                    className="nav-arrows"
                  />
                </div>
              </div> */}
              {/* <div dangerouslySetInnerHTML={{ __html: currentPage.content }} /> */}
            </div>
           
            {allNews.map((data, key) => {

              if (data.node.id === wpNews.id) {
                const previousData = key + 1;

                const totalItems = allNews.length;

                if (previousData <= totalItems - 1) {
                  let content = allNews[previousData].node.content;
                  const wordsPerMinute = 200;
                  const wordCount = content.split(/\s+/).length;
                  const readingTimeMinutes = Math.ceil(
                    wordCount / wordsPerMinute
                  );

                  const dateObject = getFormatDate(allNews[previousData].node.press_release_acf.publishedDate);
                  const displayDate = format(dateObject, 'MMMM d, yyyy');

                  var date = displayDate;
                  var arr1 = date.split(' ');
                  var arr2 = arr1[1].split(',');
                  var arr3 = arr1[2];
                  var month = arr1[0];

                  console.log(arr2,"arr2");
                  console.log(arr3,"arr3");
                  console.log(arr1[0],"arr1");
                  
                  // var nextnewsandinsightsdate = translateDate(month,wpNews.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[wpNews.locale.id] +arr3;

                  if(wpNews.locale.id=="ar"){
                    var nextnewsandinsightsdate = arr2[0]+' '+translateDate(month,wpNews.locale.id)+SiteTrans.comma_article_txt[wpNews.locale.id]+arr3;
                  }else{
                    var nextnewsandinsightsdate = translateDate(month,wpNews.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[wpNews.locale.id]+arr3;
                  }

                  return (
                    <Link to={allNews[previousData].node.link} className="stickyCustomNav stickyCustomNavNext">
                      <div className="news-next-navigation-cards-wrapper news-navigation-wrapper">
                        <div className="position-relative d-flex flex-row align-items-center news-next-navigation-container">
                          {/* <img
                        src={
                          allNews[previousData].node.featuredImage ? allNews[previousData].node.featuredImage.node.sourceUrl : 'https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png'
                        }
                        alt="Jameel Motors"
                        className="news-navigation-card-poster"
                      /> */}
                          <GatsbyImage className="news-navigation-card-poster"
                            image={getImage(allNews[previousData].node.featuredImage ? allNews[previousData].node.featuredImage.node : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png")}
                            alt={"Jameel Motors"} />
                          <div className="news-nav-gradient position-absolute"></div>
                          <div className="arrow-nav-label-wrapper position-absolute d-flex flex-column justify-content-center align-items-center gap-2">
                            <img
                              src={newsNavRightArrow}
                              alt="Jameel Motors"
                              className="nav-arrows"
                            />
                            <div className="nav-label">
                            {SiteTrans.read_txt[wpNews.locale.id]}
                              <br />
                              {SiteTrans.next_txt[wpNews.locale.id]}
                            </div>
                          </div>
                        </div>
                        <div className="news-navigation-card-title font-md">
                          {
                            allNews[previousData].node.press_release_acf
                              .shortTitle
                          }
                        </div>

                        <div className="nav-location-date-clock-wrapper flex-row justify-content-start align-items-center">
                          <img
                            src={locationBlack}
                            alt="Jameel Motors"
                            className="location-icon"
                          />
                          <span className="location-label">
                            {
                              allNews[previousData].node.press_release_acf
                                .location
                            }
                          </span>
                          <div className="news-location-divider"></div>
                          <span className="location-label">
                            {
                              nextnewsandinsightsdate
                            }
                          </span>
                          <div className="news-location-divider"></div>
                          <img
                            src={clockBlack}
                            alt="Jameel Motors"
                            className="clock-icon"
                          />
                          <span className="location-label">
                            {readingTimeMinutes} {SiteTrans.minute_read_txt[wpNews.locale.id]}
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                } else {

                }
              }
            })}
          </div>
        </section>
        {wpNews.press_release_acf.footnotes ?
          <div className={`foot-note-wrapper ${isFootnotesOpen ? 'footnotes-open' : 'footnotes-closed'}`}>
            <div className="container ps-4 pe-4">
              <div className="foot-note-title" onClick={() => toggleFootnotes(isFootnotesOpen)}>{SiteTrans.footnote_lable[wpNews.locale.id]}</div>
              <div ref={footNotesDescriptionRef} className="foot-note-description font-exsm">
                {/* <div dangerouslySetInnerHTML={__html.wpNews.press_release_acf.footnotes} /> */}
                <div dangerouslySetInnerHTML={{ __html: wpNews.press_release_acf.footnotes }} />
                {/* {wpNews.press_release_acf.footnotes} */}
              </div>
            </div>
          </div>
          : null}

{limitedRelatedNews.length ?
        <section className="related-articles-wrapper">
          <div className="container">
            <div className="d-flex flex-row justify-content-between align-items-center gap-2 mb-4 flex-wrap">
              <h4 className="related-articles-title font-xl">{SiteTrans.related_articles_txt[wpNews.locale.id]}</h4>
              <Link to={viewAllLinkQuickReads}>
                <ActionsButtons
                  isDark={true}
                  label={SiteTrans.view_all_quick_reads[wpNews.locale.id]}
                  isLarge={false}
                  isWatchNow={false}
                  fontColor="#000"
                  bgColor="transparent"
                  borderColor="#000"
                  actionButtonIcon={rightArrow}
                />
              </Link>
            </div>
            <div className="row row-cols-xl-2">
              {limitedRelatedNews.map((item, i) => (

                <div className="related-article-card-wrapper d-flex gap-3 mb-3">
                  <Link to={item.node.link}>
                    {/* <img
                      src={item.node.featuredImage ? item.node.featuredImage.node.sourceUrl : 'https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png'}
                      alt="Jameel motors"
                      className="related-article-poster"
                    /> */}

                    <GatsbyImage className="related-article-poster"
                      image={getImage(item.node.featuredImage ? item.node.featuredImage.node : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png")}
                      alt={"Jameel Motors"} />
                  </Link>
                  <div className="align-items-start d-flex flex-column justify-content-start">
                    {item.node.quickreadscategories.nodes[0] ?
                      <div className="related-article-type-card font-exsm">{item.node.quickreadscategories.nodes[0].name}</div>
                      : null}
                    <Link to={item.node.link}>
                      <div className="relaed-article-descrtiption">
                        {item.node.title}
                      </div>
                    </Link>
                  </div>
                </div>
              ))}

              {/* <div className="related-article-card-wrapper d-flex gap-3 mb-3">
              <img
                src={newsListSpotlightBanner}
                alt="Jameel motors"
                className="related-article-poster"
              />
              <div className="align-items-start d-flex flex-column justify-content-start">
                <div className="related-article-type-card font-exsm">SERIES</div>
                <div className="relaed-article-descrtiption">
                  Abdul Latif Jameel Motors And Saudi Automobile And Motorcycle
                  Federation Launch Gazoo Racing School
                </div>
              </div>
            </div> */}
            </div>
          </div>
        </section>
        : null}
      </div>
    </Layout>
  );
};

export default Page;
export const painPage = graphql`
query painPage($id: String!, $lang: ID!) {
  wpQuickreads(id: {eq: $id}) {
    content
    link
    id
    title
    slug
    localizedWpmlUrl
    publishStatus {
      status
    }
    featuredImage {
      node {
        sourceUrl
        gatsbyImage(width: 1320, placeholder: BLURRED)
        altText
        caption
      }
    }
    locale {
      id
      locale
    }
    seo {
      opengraphTitle
      opengraphDescription
    }
    press_release_acf {
      footnotes
      publishedDate
      location
      featured
      shortTitle
      summary
    }
    quickreadscategories {
      nodes {
        id
        name
      }
    }
    translated {
      id
      uri
      localizedWpmlUrl
      locale {
        id
        locale
      }
      publishStatus {
        status
      }
      slug
      title
      link
    }
  }
  allWpQuickreads(filter: {locale: {id: {eq: $lang}}}, sort: {date: DESC}) {
    edges {
      node {
        id
        title
        link
        content
        publishStatus {
          status
        }
        featuredImage {
          node {
            sourceUrl
            gatsbyImage(width: 1320, placeholder: BLURRED)
            altText
          }
        }
        quickreadscategories {
          nodes {
            id
            name
          }
        }
        press_release_acf {
          publishedDate
          location
          featured
          shortTitle
          summary
        }
      }
    }
  }
}
`;
